import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ParameterForm = () => {
  const { compName } = useParams();
  const [parameters, setParameters] = useState([
    { parameterName: "", parameterWeightage: "" },
  ]);

  const navigate = useNavigate();

  const handleAddParameter = () => {
    setParameters([
      ...parameters,
      { parameterName: "", parameterWeightage: "" },
    ]);
  };

  const handleRemoveParameter = (index) => {
    const updatedParameters = [...parameters];
    updatedParameters.splice(index, 1);
    setParameters(updatedParameters);
  };

  const handleParameterChange = (index, event) => {
    const { name, value } = event.target;
    const updatedParameters = [...parameters];
    updatedParameters[index][name] = value;
    setParameters(updatedParameters);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(compName);
    Axios.post(
      "https://ashish.moodi.org/multicity/set_mul_parameters",
      {
        competition: compName,
        parameters: parameters,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res.data.status === "done") {
          alert("Parameters added successfully");
          setParameters([{ parameterName: "", parameterWeightage: "" }]);
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <h2>Parameter Form - {compName}</h2>
      <form onSubmit={handleSubmit}>
        {parameters.map((parameter, index) => (
          <div className="input-group w-50 my-3" key={index}>
            <input
              type="text"
              name="parameterName"
              placeholder="Parameter Name"
              value={parameter.parameterName}
              onChange={(e) => handleParameterChange(index, e)}
              className="form-control"
            />
            <input
              type="number"
              name="parameterWeightage"
              placeholder="Parameter Weightage"
              value={parameter.parameterWeightage}
              onChange={(e) => handleParameterChange(index, e)}
              className="form-control"
            />
            {index > 0 && (
              <button
                type="button"
                className="btn btn-outline-danger col-2"
                onClick={() => handleRemoveParameter(index)}
              >
                Remove
              </button>
            )}
          </div>
        ))}
        <button
          className="btn btn-outline-primary col-sm-2"
          type="button"
          onClick={handleAddParameter}
        >
          Add Parameter
        </button>
        <button className="btn btn-primary col-sm-2" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
};

export default ParameterForm;
